import { BaseTemplate } from './TemplateManager.types';

const compareText = (a: string, b: string) => a.localeCompare(b, undefined, { sensitivity: 'base' });

/** Sorts by one value. A null value stays last whichever way the sort runs, and ties fall back to the label. */
export const sortByColumn = <T extends BaseTemplate>(
    items: T[],
    getValue: (item: T) => string | null,
    order: number | null | undefined = 1,
): T[] => {
    const direction = order === -1 ? -1 : 1;
    return [...items].sort((a, b) => {
        const valueA = getValue(a);
        const valueB = getValue(b);
        if (valueA !== valueB) {
            if (valueA === null) return 1;
            if (valueB === null) return -1;
            const byValue = compareText(valueA, valueB) * direction;
            if (byValue !== 0) return byValue;
        }
        return compareText(a.label, b.label);
    });
};

export const sortTemplates = <T extends BaseTemplate>(
    items: T[],
    sortGroup?: (item: T) => string | null,
): T[] => sortByColumn(items, sortGroup ?? (() => null));
